{
  " · изменён": " · edited",
  " · печатает": " · typing",
  "# Python: проверка подписи\nimport hmac, hashlib, time\n\ndef verify(headers, raw_body: bytes, secret: str) -> bool:\n    ts = headers[\"X-Lumo-Timestamp\"]\n    mac = hmac.new(secret.encode(), f\"{ts}.\".encode() + raw_body, hashlib.sha256).hexdigest()\n    return hmac.compare_digest(\"sha256=\" + mac, headers[\"X-Lumo-Signature\"]) and abs(time.time() - int(ts)) < 300": "# Python: verify the signature\nimport hmac, hashlib, time\n\ndef verify(headers, raw_body: bytes, secret: str) -> bool:\n    ts = headers[\"X-Lumo-Timestamp\"]\n    mac = hmac.new(secret.encode(), f\"{ts}.\".encode() + raw_body, hashlib.sha256).hexdigest()\n    return hmac.compare_digest(\"sha256=\" + mac, headers[\"X-Lumo-Signature\"]) and abs(time.time() - int(ts)) < 300",
  "# зависимости и сборка": "# dependencies and build",
  "# запуск под PM2": "# run under PM2",
  "# миграции и демо-данные": "# migrations and demo data",
  "(вы)": "(you)",
  "+1 минута": "+1 minute",
  ", при превышении — 429 и": "; when exceeded — 429 and",
  ", чтобы получить следующую страницу (": " to get the next page (",
  ". Токен действует от имени владельца: видны только доступные ему доски, а права ограничены скоупами токена. Токен показывается один раз, у него есть срок действия и журнал последнего использования; отозванный токен сразу получает 401.": ". The token acts on behalf of its owner: only the boards they can access are visible, and permissions are limited by the token scopes. The token is shown once, it has an expiry date and a last-used log; a revoked token gets 401 immediately.",
  "// Node.js: проверка подписи\nimport crypto from 'node:crypto';\n\nfunction verify(req, rawBody, secret) {\n  const ts = req.headers['x-lumo-timestamp'];\n  const expected = 'sha256=' + crypto.createHmac('sha256', secret).update(`${ts}.${rawBody}`).digest('hex');\n  const ok = crypto.timingSafeEqual(Buffer.from(expected), Buffer.from(req.headers['x-lumo-signature'] ?? ''));\n  const fresh = Math.abs(Date.now() / 1000 - Number(ts)) < 300; // защита от повтора\n  return ok && fresh;\n}": "// Node.js: verify the signature\nimport crypto from 'node:crypto';\n\nfunction verify(req, rawBody, secret) {\n  const ts = req.headers['x-lumo-timestamp'];\n  const expected = 'sha256=' + crypto.createHmac('sha256', secret).update(`${ts}.${rawBody}`).digest('hex');\n  const ok = crypto.timingSafeEqual(Buffer.from(expected), Buffer.from(req.headers['x-lumo-signature'] ?? ''));\n  const fresh = Math.abs(Date.now() / 1000 - Number(ts)) < 300; // replay protection\n  return ok && fresh;\n}",
  "1 год": "1 year",
  "30 дней": "30 days",
  "7 дней": "7 days",
  "90 дней": "90 days",
  "; передайте его в": "; pass it in",
  "API и вебхуки": "API and webhooks",
  "API-токенов активно": "Active API tokens",
  "API-токены": "API tokens",
  "Customer journey map": "Customer journey map",
  "Email используется для входа и уведомлений": "Email is used for signing in and notifications",
  "Lumo отправляет POST-запрос с JSON при событиях на досках воркспейса. Каждый запрос подписан HMAC-SHA256.": "Lumo sends a POST request with JSON when events happen on the workspace boards. Every request is signed with HMAC-SHA256.",
  "Lumo — на главную": "Lumo — home",
  "Lumo — онлайн-доска для мозговых штурмов, ретро, схем и планирования. Работает в браузере и на планшете, а данные остаются на вашем сервере.": "Lumo is an online whiteboard for brainstorms, retros, diagrams and planning. It works in the browser and on tablets, and your data stays on your server.",
  "Mind map": "Mind map",
  "N — стикер, S — фигура, T — текст": "N — sticky note, S — shape, T — text",
  "PM2, SQLite в режиме WAL и папка с файлами. Бэкап — одной командой.": "PM2, SQLite in WAL mode and a folder with files. Backup is a single command.",
  "REST API для досок, объектов и комментариев плюс вебхуки о событиях. Всё, что создано через API, мгновенно появляется у участников, открывших доску.": "REST API for boards, objects and comments plus webhooks for events. Everything created via the API shows up instantly for everyone who has the board open.",
  "REST API с токенами и подписанные вебхуки — подключайте доски к своим процессам.": "REST API with tokens and signed webhooks — connect boards to your own workflows.",
  "SWOT-анализ": "SWOT analysis",
  "Sync-сервер недоступен": "The sync server is unavailable",
  "Unix-время отправки, секунды": "Unix time of sending, seconds",
  "User story map": "User story map",
  "YouTube, Vimeo, Figma, Google Docs — живые; остальные ссылки — карточкой с превью.": "YouTube, Vimeo, Figma, Google Docs are live; other links become a card with a preview.",
  "`append` — добавить объекты (новые id), `replace` — заменить содержимое (перед заменой сохраняется версия; нужна роль owner). Скоуп: `boards:write`.": "`append` adds objects (with new ids), `replace` replaces the content (a version is saved before replacing; requires the owner role). Scope: `boards:write`.",
  "id пользователей": "user ids",
  "sha256=HMAC_SHA256(secret, timestamp + \".\" + body) в hex": "sha256=HMAC_SHA256(secret, timestamp + \".\" + body) in hex",
  "useEditor вне EditorContext": "useEditor outside EditorContext",
  "{ \"error\": { \"code\": \"validation_failed\", \"message\": \"Некорректные данные\", \"details\": [...] } }": "{ \"error\": { \"code\": \"validation_failed\", \"message\": \"Invalid data\", \"details\": [...] } }",
  "{i} из {n}": "{i} of {n}",
  "{name} — администратор": "{name} is now an administrator",
  "{n} активны за неделю": "{n} active this week",
  "{n} заблок.": "{n} blocked",
  "{n} командных воркспейсов": "{n} team workspaces",
  "{pub} публичных · {trash} в корзине": "{pub} public · {trash} in trash",
  "{who} оставил(а) комментарий на {board}": "{who} commented on {board}",
  "{who} ответил(а) в обсуждении на {board}": "{who} replied in a thread on {board}",
  "{who} поделился(ась) доской {board}": "{who} shared the board {board}",
  "{who} приглашает вас в «{ws}»": "{who} invites you to «{ws}»",
  "{who} упомянул(а) вас в комментарии на {board}": "{who} mentioned you in a comment on {board}",
  "· Открыть в Lumo": "· Open in Lumo",
  "· отозван": "· revoked",
  "Аватар обновлён": "Avatar updated",
  "Автосохранение": "Autosave",
  "Админ": "Admin",
  "Администратор": "Administrator",
  "Администрирование": "Administration",
  "Администрирование: доски": "Administration: boards",
  "Администрирование: настройки инстанса": "Administration: instance settings",
  "Администрирование: обзор": "Administration: overview",
  "Администрирование: пользователи": "Administration: users",
  "Админы": "Admins",
  "Адрес": "Address",
  "Адрес во внутренней сети запрещён": "Addresses in the internal network are not allowed",
  "Адрес должен отвечать кодом 2xx за 10 секунд. При ошибках — до 8 повторов с растущей паузой.": "The URL must respond with a 2xx code within 10 seconds. On errors — up to 8 retries with growing delays.",
  "Адрес ссылки": "Link address",
  "Адрес: латиница, цифры и дефис, от 3 символов": "Address: Latin letters, digits and hyphens, at least 3 characters",
  "Аккаунт": "Account",
  "Аккаунт заблокирован администратором": "The account is blocked by an administrator",
  "Аккаунт заблокирован администратором: {n}": "The account is blocked by an administrator: {n}",
  "Активен": "Active",
  "Активности пользователя, шаги и релизы.": "User activities, steps and releases.",
  "Активность": "Activity",
  "Анонимно": "Anonymous",
  "Аутентификация": "Authentication",
  "Базовые": "Basics",
  "Баннер увидят все пользователи на дашборде, в настройках и на досках. Например, о плановых работах.": "Every user will see the banner on the dashboard, in settings and on boards. For example, about scheduled maintenance.",
  "Без Docker и облаков": "No Docker or clouds",
  "Без заливки": "No fill",
  "Без названия": "Untitled",
  "Без наконечника": "No arrowhead",
  "Без платных тарифов и урезанных функций: всё доступно сразу.": "No paid plans or cut-down features: everything is available right away.",
  "Без сетки": "No grid",
  "Без фона — прозрачная подложка": "No background — transparent",
  "Белый": "White",
  "Бессрочно": "Never",
  "Бирюзовый": "Teal",
  "Блок-схема": "Flowchart",
  "Блокировка сразу завершает сессии и отключает API-токены пользователя. Доски и данные сохраняются.": "Blocking ends all sessions immediately and disables the user’s API tokens. Boards and data are kept.",
  "Бриф и брейншторм": "Brief and brainstorm",
  "Быстрый старт": "Quick start",
  "В production нужен https": "https is required in production",
  "В галерее": "In the gallery",
  "В корзину": "Move to trash",
  "В корзину…": "Move to trash…",
  "В личное пространство нельзя приглашать по ссылке — создайте командный воркспейс": "You can’t invite to a personal space by link — create a team workspace",
  "В очереди": "Queued",
  "В порядке слоёв (снизу вверх). Пагинация курсором. Скоуп: `boards:read`.": "In layer order (bottom to top). Cursor pagination. Scope: `boards:read`.",
  "В работе": "In progress",
  "Вариант": "Option",
  "Вас": "you",
  "Ваши доски — на вашем сервере": "Your boards — on your server",
  "Введите пароль, который вам сообщил владелец доски.": "Enter the password the board owner gave you.",
  "Вебхук": "Webhook",
  "Вебхук включён": "Webhook enabled",
  "Вебхук не найден": "Webhook not found",
  "Вебхук отключён": "Webhook disabled",
  "Вебхук удалён или у вас нет прав администратора.": "The webhook was deleted or you are not an administrator.",
  "Вебхуками управляют администраторы воркспейса": "Webhooks are managed by workspace administrators",
  "Вебхуками управляют владелец и администраторы воркспейса.": "Webhooks are managed by the workspace owner and administrators.",
  "Вебхуки": "Webhooks",
  "Вебхуков активно": "Active webhooks",
  "Вектор": "Vector",
  "Версии появятся автоматически каждые 10 минут работы над доской.": "Versions are saved automatically every 10 minutes of work on the board.",
  "Версия": "Version",
  "Версия восстановлена": "Version restored",
  "Версия не найдена": "Version not found",
  "Версия сохранена": "Version saved",
  "Вид": "View",
  "Видит только доски, куда приглашён": "Sees only the boards they’re invited to",
  "Включение сбрасывает счётчик ошибок": "Enabling resets the error counter",
  "Владелец": "Owner",
  "Владелец запретил копировать эту доску": "The owner doesn’t allow copying this board",
  "Владелец не может покинуть воркспейс": "The owner can’t leave the workspace",
  "Вместе в реальном времени": "Together in real time",
  "Вместе с объектом удаляются привязанные коннекторы. Скоуп: `boards:write`, роль editor.": "Connectors attached to the object are deleted with it. Scope: `boards:write`, editor role.",
  "Внутренние имена запрещены": "Internal host names are not allowed",
  "Внутренняя ошибка сервера": "Internal server error",
  "Возможно, её сделали приватной.": "It may have been made private.",
  "Возможно, оно устарело или уже использовано.": "It may be outdated or already used.",
  "Возможности": "Features",
  "Войдите, чтобы комментировать": "Sign in to comment",
  "Войти": "Sign in",
  "Вопросы к дизайну?": "Design questions?",
  "Воркспейс": "Workspace",
  "Воркспейс не найден": "Workspace not found",
  "Воркспейсы": "Workspaces",
  "Воркспейсы пользователя": "User’s workspaces",
  "Восстановить": "Restore",
  "Восстановить версию?": "Restore this version?",
  "Восстановить доску может владелец": "Only the owner can restore the board",
  "Восстановить можно в течение 30 дней. Скоуп: `boards:write`, роль owner.": "Can be restored within 30 days. Scope: `boards:write`, owner role.",
  "Восстановить эту версию": "Restore this version",
  "Время!": "Time’s up!",
  "Все": "All",
  "Все вебхуки": "All webhooks",
  "Все доски": "All boards",
  "Все доски «{name}» будут удалены без возможности восстановления.": "All boards in «{name}» will be deleted permanently.",
  "Все доски воркспейса": "All workspace boards",
  "Все доски инстанса": "All boards on the instance",
  "Все команды —": "All commands —",
  "Все объекты, тексты и настройки доски. Файл можно импортировать в любую доску Lumo. Картинки остаются ссылками на файлы этого сервера.": "All objects, texts and board settings. The file can be imported into any Lumo board. Images stay as links to files on this server.",
  "Все пользователи инстанса": "All users on the instance",
  "Встречи на доске": "Meetings on the board",
  "Встроенный контент": "Embedded content",
  "Встроить": "Embed",
  "Встроить ссылку": "Embed a link",
  "Встроить ссылку или видео": "Embed a link or video",
  "Вся доска": "Whole board",
  "Всё для мышления": "Everything for thinking",
  "Всё, что нужно команде, — на одном холсте": "Everything a team needs — on one canvas",
  "Вход": "Sign in",
  "Вход через этого провайдера не настроен": "Sign-in with this provider isn’t configured",
  "Вчера": "Yesterday",
  "Вы": "You",
  "Вы потеряете доступ к его доскам, пока вас не пригласят снова.": "You’ll lose access to its boards until you’re invited again.",
  "Вы присоединитесь": "You’ll join",
  "Выберите события": "Select events",
  "Выберите файл или перетащите его сюда": "Choose a file or drop it here",
  "Выберите хотя бы одно право": "Select at least one permission",
  "Выберите, с чего начать, или нажмите клавишу": "Pick where to start or press a key",
  "Выдавайте только нужные права. Токен можно отозвать в любой момент.": "Grant only the permissions you need. The token can be revoked at any time.",
  "Выделение": "Select",
  "Выделенное": "Selection",
  "Выделить всё": "Select all",
  "Выйти": "Sign out",
  "Выключено — доску нельзя сделать публичной. Уже опубликованные снимаются в разделе «Доски».": "Off — boards can’t be made public. Already published ones can be unpublished in the «Boards» section.",
  "Выключено — новые пользователи попадают только по приглашению в воркспейс или на доску. В .env: ALLOW_SIGNUP={value}": "Off — new users join only by invitation to a workspace or a board. In .env: ALLOW_SIGNUP={value}",
  "Выполнено: {item}": "Done: {item}",
  "Выпустить": "Issue",
  "Выпустить новый секрет": "Issue a new secret",
  "Выпустить новый секрет?": "Issue a new secret?",
  "Выстроить по голосам": "Arrange by votes",
  "ГБ": "GB",
  "Галерея": "Gallery",
  "Галерея досок": "Board gallery",
  "Галерея публичных досок": "Public board gallery",
  "Где голосуем": "Where we vote",
  "Голоса закончились — кликните по своей точке, чтобы забрать голос": "You’re out of votes — click your own dot to take a vote back",
  "Голосов не было": "There were no votes",
  "Голосов у каждого": "Votes per person",
  "Голосование": "Voting",
  "Голосование идёт внутри выбранного фрейма": "Voting is limited to the selected frame",
  "Голосование точками, таймер, режим презентации по фреймам и лазерная указка.": "Dot voting, a timer, presentation mode by frames and a laser pointer.",
  "Голубой": "Sky",
  "Горячие клавиши": "Keyboard shortcuts",
  "Гость": "Guest",
  "Готово": "Done",
  "Готовые структуры для ретро, планирования, исследований и схем.": "Ready-made structures for retros, planning, research and diagrams.",
  "Графит": "Graphite",
  "Двойной клик — редактировать текст": "Double-click to edit text",
  "Дедлайн": "Due date",
  "Действия": "Actions",
  "Действия с комментарием": "Comment actions",
  "Действия: {name}": "Actions: {name}",
  "Действует в этом браузере. Письма пока приходят на русском.": "Applies to this browser. Emails are still sent in Russian.",
  "Демо-доска": "Demo board",
  "Для доступа к доске нужен пароль": "A password is required to access the board",
  "Добавить вебхук": "Add webhook",
  "Добавить к доске": "Add to board",
  "Добавить пункт": "Add item",
  "Добавить реакцию": "Add reaction",
  "Добавить столбец": "Add column",
  "Добавить строку": "Add row",
  "Добавлен участник": "Member added",
  "Добавлены объекты": "Objects added",
  "Добавьте адрес, чтобы получать события о досках в своём сервисе.": "Add a URL to receive board events in your service.",
  "Добавьте фреймы (F) — они станут слайдами": "Add frames (F) — they become slides",
  "Добро пожаловать в Lumo": "Welcome to Lumo",
  "Добро пожаловать!": "Welcome!",
  "Документ": "Document",
  "Документация API": "API documentation",
  "Доска": "Board",
  "Доска в корзине": "Board moved to trash",
  "Доска в корзине — её можно восстановить в течение 30 дней": "The board is in the trash — it can be restored within 30 days",
  "Доска восстановлена": "Board restored",
  "Доска защищена паролем": "The board is password-protected",
  "Доска не найдена": "Board not found",
  "Доска не найдена в корзине": "Board not found in the trash",
  "Доска не найдена в этом воркспейсе": "Board not found in this workspace",
  "Доска недоступна": "Board unavailable",
  "Доска переименована или изменены настройки": "Board renamed or settings changed",
  "Доска перемещена": "Board moved",
  "Доска удалена": "Board deleted",
  "Доска удалена навсегда": "Board deleted permanently",
  "Доска уже открыта, инициализация невозможна": "The board is already open, it can’t be initialized",
  "Доски": "Boards",
  "Доски проекта не удалятся — они останутся в воркспейсе без проекта.": "The project’s boards won’t be deleted — they stay in the workspace without a project.",
  "Доски, доступные пользователю, от новых к старым. Пагинация курсором. Скоуп: `boards:read`.": "Boards available to the user, newest first. Cursor pagination. Scope: `boards:read`.",
  "Досок нет": "No boards",
  "Доставка ещё в очереди": "The delivery is still queued",
  "Доставка не найдена": "Delivery not found",
  "Доставка поставлена в очередь": "Delivery queued",
  "Доставка:": "Delivery:",
  "Доставлено": "Delivered",
  "Доставок пока не было. Отправьте тестовое событие, чтобы проверить адрес.": "No deliveries yet. Send a test event to check the URL.",
  "Доступ": "Access",
  "Доступ выдан": "Access granted",
  "Доступ под контролем": "Access under control",
  "Доступна только воркспейсу": "Visible to the workspace only",
  "Дочерний узел": "Child node",
  "Дублировать к себе": "Duplicate to my boards",
  "Думайте вместе на": "Think together on an",
  "Ещё инструменты": "More tools",
  "Ещё не использовался": "Never used",
  "Ещё одна": "One more",
  "Живая доска": "Live board",
  "Жирный (Ctrl+B)": "Bold (Ctrl+B)",
  "Журнал доставок": "Delivery log",
  "Жёлтый": "Yellow",
  "За один запрос можно создать не более {n} объектов": "You can create at most {n} objects per request",
  "Заблокирован": "Blocked",
  "Заблокированные": "Blocked",
  "Заблокировать": "Block",
  "Заблокировать {name}?": "Block {name}?",
  "Заблокировать…": "Block…",
  "Завершено голосование": "Voting finished",
  "Завершить": "Finish",
  "Завершить показ": "End presentation",
  "Заголовок": "Title",
  "Заголовок X-Lumo-Signature = sha256=HMAC_SHA256(секрет, `${X-Lumo-Timestamp}.${тело}`).": "Header X-Lumo-Signature = sha256=HMAC_SHA256(secret, `${X-Lumo-Timestamp}.${body}`).",
  "Загружаем изображение…": "Uploading image…",
  "Загружаем изображения: {n}…": "Uploading images: {n}…",
  "Загрузить": "Upload",
  "Загрузка картинок доступна на досках в аккаунте": "Image upload is available on boards in your account",
  "Задать пароль": "Set password",
  "Задача worker": "Worker job",
  "Задачи": "Tasks",
  "Закрыть": "Close",
  "Закрыть итоги": "Close results",
  "Закрыть меню": "Close menu",
  "Закрыть поиск": "Close search",
  "Заменить содержимое": "Replace content",
  "Заметки к доске": "Board notes",
  "Заметок пока нет": "No notes yet",
  "Запуск новой версии": "Launching a new version",
  "Зачёркнутый": "Strikethrough",
  "Здесь пока ничего нет": "Nothing here yet",
  "Зелёный": "Green",
  "Иван": "Ivan",
  "Идеи": "Ideas",
  "Идеи на неделю": "Ideas for the week",
  "Идеи на пятницу": "Ideas for Friday",
  "Идентификатор доставки (у повторов — новый)": "Delivery ID (new for every retry)",
  "Идентификатор события — для дедупликации": "Event ID — for deduplication",
  "Идея": "Idea",
  "Идея из API": "Idea from the API",
  "Избранное": "Favorites",
  "Изменение досок": "Editing boards",
  "Изменения сохраняются в браузере и сливаются без конфликтов, когда связь вернётся.": "Changes are saved in the browser and merge without conflicts when the connection is back.",
  "Изменено": "Edited",
  "Изменены объекты": "Objects changed",
  "Изменить": "Edit",
  "Изменить вебхук": "Update webhook",
  "Изменить объект": "Update object",
  "Илья": "Ilya",
  "Импорт JSON в доску": "Import JSON into a board",
  "Импорт из JSON": "Import from JSON",
  "Импорт из JSON…": "Import from JSON…",
  "Импортировано объектов: {n}": "Objects imported: {n}",
  "Импортировать": "Import",
  "Имя": "Name",
  "Имя или email": "Name or email",
  "Имя не резолвится": "The host name doesn’t resolve",
  "Инстанс": "Instance",
  "Инструменты": "Tools",
  "Инструменты демо-доски": "Demo board tools",
  "Интеграции": "Integrations",
  "Информация": "Information",
  "Исполнитель": "Assignee",
  "Использован {time}": "Used {time}",
  "Использован {time} с {ip}": "Used {time} from {ip}",
  "Исследования": "Research",
  "История версий": "Version history",
  "Истёк": "Expired",
  "Итоги голосования": "Voting results",
  "Ищем…": "Searching…",
  "К выполнению": "To do",
  "КБ": "KB",
  "Каждый запрос — с заголовком": "Every request has the header",
  "Как проверить подпись": "How to verify the signature",
  "Как работают вебхуки": "How webhooks work",
  "Канбан-доска": "Kanban board",
  "Картинка": "Image",
  "Картинка недоступна": "The image is unavailable",
  "Карточка задачи": "Task card",
  "Качество": "Quality",
  "Квадрат": "Square",
  "Ко всем доскам": "All boards",
  "Код скопирован": "Code copied",
  "Колонка": "Column",
  "Колонки-фреймы и карточки задач — перетаскивайте между колонками.": "Frame columns and task cards — drag them between columns.",
  "Команда продукта": "Product team",
  "Комментарии": "Comments",
  "Комментарии (C — оставить)": "Comments (C — add one)",
  "Комментарий не найден": "Comment not found",
  "Комментарий… @ — упомянуть": "Comment… @ to mention",
  "Комментирование": "Commenting",
  "Конец линии": "Line end",
  "Копирования": "Copies",
  "Копировать": "Copy",
  "Копия создана": "Copy created",
  "Копия создана в ваших досках": "A copy was created in your boards",
  "Коралловый": "Coral",
  "Корзина": "Trash",
  "Красный": "Red",
  "Кривая": "Curve",
  "Круг": "Circle",
  "Кто-то": "Someone",
  "Курсив (Ctrl+I)": "Italic (Ctrl+I)",
  "Курсор из `nextCursor` предыдущей страницы": "Cursor from `nextCursor` of the previous page",
  "Курсоры, выделения и правки коллег видны сразу. Следуйте за ведущим или позовите всех к себе.": "Teammates’ cursors, selections and edits appear instantly. Follow the presenter or bring everyone to you.",
  "Лавандовый": "Lavender",
  "Лаймовый": "Lime",
  "Лена": "Lena",
  "Лимит загрузки": "Upload limit",
  "Личное пространство": "Personal space",
  "Личное пространство удалить нельзя": "The personal space can’t be deleted",
  "Личный воркспейс не найден": "Personal workspace not found",
  "Ломаная": "Elbow",
  "Любой, у кого есть ссылка, сможет присоединиться": "Anyone with the link can join",
  "МБ": "MB",
  "Мария": "Maria",
  "Масштаб 100%": "Zoom to 100%",
  "Масштаб {pct}%": "Zoom {pct}%",
  "Масштаб — Ctrl/⌘ + колесо или жест на тачпаде. Всё, что вы нарисуете здесь, останется только в вашем браузере.": "Zoom — Ctrl/⌘ + wheel or a trackpad gesture. Everything you draw here stays only in your browser.",
  "Маша": "Masha",
  "Меню": "Menu",
  "Место на диске": "Disk usage",
  "Минимум 8 символов": "At least 8 characters",
  "Минут": "Minutes",
  "Модерация: снять доску с публикации, убрать из галереи или отправить в корзину. Содержимое досок администратору не открывается, кроме публичных.": "Moderation: unpublish a board, remove it from the gallery or move it to the trash. Administrators can’t open board contents, except public ones.",
  "Может менять доску": "Can edit the board",
  "Мои": "Mine",
  "Мои доски": "My boards",
  "Мои токены": "My tokens",
  "Мятный": "Mint",
  "На главную": "Go home",
  "На доске": "On the board",
  "На проверке": "In review",
  "Навигация": "Navigation",
  "Нажмите C и кликните по доске, чтобы оставить комментарий.": "Press C and click the board to leave a comment.",
  "Назад": "Back",
  "Название": "Name",
  "Название версии": "Version name",
  "Название воркспейса": "Workspace name",
  "Название доски": "Board name",
  "Название или email владельца": "Name or owner email",
  "Название фрейма": "Frame name",
  "Название шаблона": "Template name",
  "Назначать администраторов может только владелец": "Only the owner can appoint administrators",
  "Назначать владельцев может только владелец": "Only the owner can appoint owners",
  "Найти доску": "Find a board",
  "Найти доску или команду…": "Find a board or command…",
  "Найти команду…": "Find a command…",
  "Найти на доске": "Find on board",
  "Например, «Интеграция с CI»": "For example, «CI integration»",
  "Например: после воркшопа": "For example: after the workshop",
  "Настройки": "Settings",
  "Настройки инстанса": "Instance settings",
  "Настройки → API-токены": "Settings → API tokens",
  "Начало линии": "Line start",
  "Начало, шаги, решение и конец, соединённые линиями.": "Start, steps, a decision and an end, joined by lines.",
  "Начать": "Get started",
  "Начать бесплатно": "Start for free",
  "Начать голосование": "Start voting",
  "Начните не с чистого листа": "Don’t start from a blank page",
  "Не больше 50 вебхуков на воркспейс": "No more than 50 webhooks per workspace",
  "Не больше {n} активных токенов": "No more than {n} active tokens",
  "Не задан": "Not set",
  "Не изображение": "Not an image",
  "Не назначен": "Unassigned",
  "Не найдено": "Not found",
  "Не прочитано": "Unread",
  "Не следовать": "Don’t follow",
  "Не удалось войти через провайдера": "Couldn’t sign in with the provider",
  "Не удалось вставить": "Couldn’t paste",
  "Не удалось загрузить спецификацию.": "Couldn’t load the specification.",
  "Не удалось записать содержимое доски": "Couldn’t save the board content",
  "Не удалось запустить графический движок. Проверьте, что в браузере включён WebGL.": "Couldn’t start the graphics engine. Make sure WebGL is enabled in your browser.",
  "Не удалось прочитать изображение": "Couldn’t read the image",
  "Не удалось скопировать": "Couldn’t copy",
  "Не удалось создать изображение": "Couldn’t create the image",
  "Не указана доска": "No board specified",
  "Неверный email или пароль": "Wrong email or password",
  "Неверный пароль": "Wrong password",
  "Недавние": "Recent",
  "Недавние доски": "Recent boards",
  "Недействительный или отозванный токен": "The token is invalid or revoked",
  "Недостаточно прав в воркспейсе": "Not enough permissions in the workspace",
  "Недостаточно прав на доске": "Not enough permissions on the board",
  "Некорректная ссылка": "Invalid link",
  "Некорректное состояние документа": "Invalid document state",
  "Некорректные данные": "Invalid data",
  "Некорректный JSON": "Invalid JSON",
  "Некорректный email": "Invalid email",
  "Некорректный id доски": "Invalid board id",
  "Некорректный адрес": "Invalid address",
  "Некорректный запрос": "Bad request",
  "Некорректный курсор": "Invalid cursor",
  "Некорректный путь": "Invalid path",
  "Некорректный файл аватара": "Invalid avatar file",
  "Нельзя снять права или заблокировать самого себя": "You can’t remove your own rights or block yourself",
  "Необязательно": "Optional",
  "Нет доступа": "No access",
  "Нет или недействительный токен": "Missing or invalid token",
  "Нет обсуждений": "No discussions",
  "Нет прав или скоупа": "No permission or scope",
  "Нет соединения с сервером": "No connection to the server",
  "Неудачных доставок за неделю": "Failed deliveries this week",
  "Никого не нашлось": "No one found",
  "Ничего": "Nothing",
  "Ничего не нашлось по запросу «": "Nothing found for «",
  "Новая задача": "New task",
  "Новое голосование": "New vote",
  "Новые": "New",
  "Новые доски": "New boards",
  "Новые публикации запрещены": "New publications are disabled",
  "Новые треды и ответы": "New threads and replies",
  "Новый вебхук": "New webhook",
  "Новый комментарий или ответ": "New comment or reply",
  "Новый комментарий… @ — упомянуть": "New comment… @ to mention",
  "Новый онбординг": "New onboarding",
  "Новый пароль": "New password",
  "Новый секрет": "New secret",
  "Новый токен": "New token",
  "Новый тред комментариев": "New comment thread",
  "Нужен эмодзи": "An emoji is required",
  "Нужны права администратора": "Administrator rights are required",
  "Нумерованный список": "Numbered list",
  "Обзор": "Overview",
  "Обзор инстанса": "Instance overview",
  "Обновляется каждые 15 секунд.": "Refreshes every 15 seconds.",
  "Обсуждение": "Discussion",
  "Обсуждение не найдено": "Discussion not found",
  "Обсуждение, комментариев: {count}": "Discussion, comments: {count}",
  "Обсуждение: {name}, комментариев: {count}": "Discussion: {name}, comments: {count}",
  "Объект": "Object",
  "Объект доски. Поля `props` зависят от `type`; `text` — rich text (ProseMirror JSON) у стикеров, фигур, текста, карточек и узлов mind map.": "A board object. `props` fields depend on `type`; `text` is rich text (ProseMirror JSON) on sticky notes, shapes, text, cards and mind map nodes.",
  "Объект не найден": "Object not found",
  "Объект с id «{n}» уже существует": "An object with id «{n}» already exists",
  "Объектов на досках": "Objects on boards",
  "Объектов на доске": "Objects per board",
  "Объекты": "Objects",
  "Объекты доски": "Board objects",
  "Объекты получат новые идентификаторы, текущее содержимое не изменится.": "Objects get new IDs; the current content stays unchanged.",
  "Объявление": "Announcement",
  "Объявление опубликовано": "Announcement published",
  "Объявление снято": "Announcement removed",
  "Один Node.js-процесс на сервис, SQLite вместо отдельной базы, никаких внешних облаков. Поднимается за пару минут.": "One Node.js process per service, SQLite instead of a separate database, no external clouds. Up and running in a couple of minutes.",
  "Один объект или пачка `{ \"objects\": [...] }` (до 500). Изменения сразу видны всем, кто открыл доску. Поле `text` — строка или rich text. Скоуп: `boards:write`, роль editor.": "A single object or a batch `{ \"objects\": [...] }` (up to 500). Changes are visible right away to everyone who has the board open. The `text` field is a string or rich text. Scope: `boards:write`, editor role.",
  "Ожидается application/json": "application/json is expected",
  "Ожидают ответа": "Awaiting reply",
  "Онбординг за 3 шага": "Onboarding in 3 steps",
  "Онлайн-доска для совместной работы": "An online whiteboard for teamwork",
  "Опасная зона": "Danger zone",
  "Описание": "Description",
  "Опрос пользователей": "User survey",
  "Опубликовать": "Publish",
  "Опубликуйте доску и включите «Показывать в галерее».": "Publish the board and turn on «Show in the gallery».",
  "Оранжевый": "Orange",
  "Основное": "General",
  "От новых к старым; хранится 30 дней.": "Newest first; kept for 30 days.",
  "Ответ": "Reply",
  "Ответ сервера": "Server response",
  "Ответить в треде": "Reply in a thread",
  "Ответить…": "Reply…",
  "Отдалить": "Zoom out",
  "Отключён": "Disabled",
  "Откройте доску и выберите в меню «Сохранить как шаблон» — команда сможет начинать с неё.": "Open a board and choose «Save as template» in the menu — your team can start from it.",
  "Открытые": "Open",
  "Открытый код": "Open source",
  "Открытый код · свой сервер · без лимитов": "Open source · self-hosted · no limits",
  "Открыть в новой вкладке": "Open in a new tab",
  "Открыть встраивание": "Open embed",
  "Открыть доску": "Open board",
  "Открыть мои доски": "Open my boards",
  "Открыть публичную страницу": "Open public page",
  "Открыть снова": "Reopen",
  "Открыть ссылку": "Open link",
  "Отмена": "Cancel",
  "Отменить": "Cancel",
  "Отменить голосование": "Cancel voting",
  "Отметить решённым": "Mark as resolved",
  "Отозван": "Revoked",
  "Отозванные": "Revoked",
  "Отозвать": "Revoke",
  "Отозвать приглашение": "Revoke invitation",
  "Отозвать приглашение {email}": "Revoke invitation {email}",
  "Отозвать токен?": "Revoke token?",
  "Отправить": "Send",
  "Отправить «{name}» в корзину?": "Move «{name}» to the trash?",
  "Отправить тестовое событие": "Send a test event",
  "Отправлять события": "Send events",
  "Отправляются, только если на сервере настроена почта": "Sent only if email is configured on the server",
  "Ошибка": "Error",
  "Ошибка {status}": "Error {status}",
  "Ошибки всегда в одном формате, код HTTP соответствует типу ошибки:": "Errors always have the same format, and the HTTP code matches the error type:",
  "Ошибки и пагинация": "Errors and pagination",
  "Ошибки, пагинация, лимиты": "Errors, pagination, limits",
  "Ошибки:": "Errors:",
  "Палитра команд": "Command palette",
  "Параметры": "Parameters",
  "Пароль": "Password",
  "Пароль изменён": "Password changed",
  "Пароль — минимум 4 символа": "Password — at least 4 characters",
  "Пароль — минимум 8 символов": "Password — at least 8 characters",
  "Пауза": "Pause",
  "Перед восстановлением": "Before restoring",
  "Передайте её {name} — ссылка действует 24 часа и сработает один раз.": "Send it to {name} — the link is valid for 24 hours and works once.",
  "Переименовать": "Rename",
  "Переименовать версию": "Rename version",
  "Переименовать или изменить описание": "Rename or change the description",
  "Перейти": "Go to",
  "Перейти к содержимому": "Skip to content",
  "Перейти к фрейму": "Go to frame",
  "Переместить доску в корзину": "Move the board to the trash",
  "Переместить можно только своё обсуждение": "You can only move your own discussion",
  "Перетаскивайте, вращайте, меняйте размер": "Drag, rotate, resize",
  "Перо": "Pen",
  "Персиковый": "Peach",
  "Персональные токены": "Personal tokens",
  "Песочница": "Sandbox",
  "Песочный": "Sand",
  "Пин ставится в точку (x, y) мира или на объект. Упомянутые пользователи получают уведомления. Скоуп: `comments:write`.": "The pin is placed at a world point (x, y) or on an object. Mentioned users get notifications. Scope: `comments:write`.",
  "Письма об упоминаниях и приглашениях": "Emails about mentions and invitations",
  "План на неделю": "Weekly plan",
  "Планирование": "Planning",
  "Плюс минута": "Plus one minute",
  "По ссылке": "Via link",
  "По умолчанию": "Default",
  "По умолчанию — личный воркспейс": "Defaults to the personal workspace",
  "Повестка, решения, ссылки… Все участники правят заметки вместе.": "Agenda, decisions, links… Everyone edits the notes together.",
  "Повторить": "Retry",
  "Повторить доставку": "Retry delivery",
  "Подвести итоги": "Show results",
  "Поддерживаются PNG, JPEG, GIF, WebP, AVIF и SVG": "PNG, JPEG, GIF, WebP, AVIF and SVG are supported",
  "Поделиться…": "Share…",
  "Подписки воркспейсов, где пользователь — администратор. Скоуп: `webhooks:manage`.": "Subscriptions of workspaces where the user is an administrator. Scope: `webhooks:manage`.",
  "Подписки настраиваются в разделе «Вебхуки» настроек воркспейса или через API. Lumo отправляет POST с JSON; ответ 2xx за 10 секунд — успех. Иначе до 8 попыток с паузами 30 с → 2 мин → 10 мин → 30 мин → 1 ч → 3 ч → 6 ч; после 20 ошибок подряд вебхук отключается. Изменения объектов собираются в пачки (не чаще раза в 2 с).": "Subscriptions are set up in the «Webhooks» section of the workspace settings or via the API. Lumo sends a POST with JSON; a 2xx response within 10 seconds counts as success. Otherwise up to 8 attempts with delays of 30 s → 2 min → 10 min → 30 min → 1 h → 3 h → 6 h; after 20 failures in a row the webhook is disabled. Object changes are batched (at most once every 2 s).",
  "Подписок пока нет": "No subscriptions yet",
  "Подпись": "Signature",
  "Подпись линии": "Line label",
  "Поиск и команды": "Search and commands",
  "Поиск по названию": "Search by name",
  "Пока тихо": "All quiet",
  "Показать": "Show",
  "Показать всю доску": "Show the whole board",
  "Показать ещё": "Show more",
  "Покинуть": "Leave",
  "Покинуть воркспейс": "Leave workspace",
  "Покинуть воркспейс?": "Leave the workspace?",
  "Пользователи": "Users",
  "Пользователь заблокирован": "User blocked",
  "Пользователь не найден": "User not found",
  "Пользователь разблокирован": "User unblocked",
  "Пользователь с таким email уже есть": "A user with this email already exists",
  "Пользователь сразу выйдет из всех сессий и не сможет войти. Причину увидит при попытке входа.": "The user will be signed out of all sessions immediately and won’t be able to sign in. They’ll see the reason when trying to sign in.",
  "Попробовать без регистрации": "Try without signing up",
  "Попросите владельца доски прислать новую ссылку.": "Ask the board owner to send a new link.",
  "Популярные": "Popular",
  "Попыток:": "Attempts:",
  "Порт запрещён": "The port is not allowed",
  "Порядок по оси Z (fractional index)": "Z-order (fractional index)",
  "После смены пароля другие сессии будут завершены.": "Other sessions will be ended after the password change.",
  "Последние 30 дней. Обновляется автоматически.": "Last 30 days. Refreshes automatically.",
  "Последний запуск": "Last run",
  "Почта (SMTP)": "Email (SMTP)",
  "Права": "Permissions",
  "Права сняты": "Rights removed",
  "Правка": "Edit",
  "Превышен лимит запросов": "Rate limit exceeded",
  "Превышен лимит объектов на доске ({n})": "The board object limit has been exceeded ({n})",
  "Предпросмотр": "Preview",
  "Предупреждение": "Warning",
  "Предыдущее": "Previous",
  "Предыдущий слайд": "Previous slide",
  "Презентация": "Present",
  "Презентация по фреймам": "Presentation by frames",
  "Приблизить": "Zoom in",
  "Пригласить": "Invite",
  "Пригласить владельцем можно только зарегистрированного пользователя": "Only a registered user can be invited as an owner",
  "Приглашение недействительно": "Invitation is invalid",
  "Приглашение недействительно или устарело": "The invitation is invalid or expired",
  "Приглашение отозвано": "Invitation revoked",
  "Приглашение отправлено": "Invitation sent",
  "Приглашение отправлено на {email}": "Invitation sent to {email}",
  "Приглашение отправлено на {n}. Войдите под этим адресом.": "The invitation was sent to {n}. Sign in with that address.",
  "Приглашение по ссылке": "Invite link",
  "Приглашения действуют 14 дней. Без SMTP ссылка из письма появится в логе сервера.": "Invitations are valid for 14 days. Without SMTP the link from the email appears in the server log.",
  "Принять приглашение": "Accept invitation",
  "Причина (необязательно)": "Reason (optional)",
  "Проблема, цель, ограничения и поле для идей.": "Problem, goal, constraints and a space for ideas.",
  "Провайдер не настроен": "The provider isn’t configured",
  "Проверка CSRF не пройдена — обновите страницу": "CSRF check failed — refresh the page",
  "Проголосовали:": "Voted:",
  "Продолжить": "Continue",
  "Проект не найден": "Project not found",
  "Проект не найден в этом воркспейсе": "Project not found in this workspace",
  "Просмотр": "View",
  "Просмотры": "Views",
  "Прототип": "Prototype",
  "Профиль": "Profile",
  "Прочее": "Other",
  "Прочитать все": "Mark all as read",
  "Прямая": "Straight",
  "Публичная": "Public",
  "Публичные": "Public",
  "Публичные доски": "Public boards",
  "Публичные доски отключены администратором": "Public boards are disabled by the administrator",
  "Публичные доски разрешены": "Public boards allowed",
  "Публичные доски сообщества: шаблоны, схемы, ретро и идеи. Откройте любую без регистрации.": "Community public boards: templates, diagrams, retros and ideas. Open any of them without signing up.",
  "Пункт": "Item",
  "Пустая доска": "Blank board",
  "Пустая доска с сеткой": "Blank board with grid",
  "Пустой комментарий": "The comment is empty",
  "Работает без сети": "Works offline",
  "Разблокировать": "Unblock",
  "Развернуть ветку": "Expand branch",
  "Разделы": "Sections",
  "Размер страницы (1–200)": "Page size (1–200)",
  "Разработчикам": "Developers",
  "Разрешены только http и https": "Only http and https are allowed",
  "Регистрации": "Sign-ups",
  "Регистрация {date}": "Signed up {date}",
  "Регистрация закрыта": "Sign-up is closed",
  "Регистрация закрыта — попросите приглашение": "Sign-up is closed — ask for an invitation",
  "Регистрация открыта": "Sign-up is open",
  "Регистрация только по приглашениям": "Sign-up by invitation only",
  "Редактирование текста": "Text editing",
  "Редактировать карточку": "Edit card",
  "Редактировать можно только свои комментарии": "You can only edit your own comments",
  "Резервная копия": "Backup",
  "Результаты": "Results",
  "Релиз": "Release",
  "Релиз готов!": "Release is ready!",
  "Ретро": "Retro",
  "Ретро в 16:00 ✦": "Retro at 4 pm ✦",
  "Ретро в пятницу": "Retro on Friday",
  "Ретро спринта 42": "Sprint 42 retro",
  "Ретро: Mad / Sad / Glad": "Retro: Mad / Sad / Glad",
  "Ретро: Start / Stop / Continue": "Retro: Start / Stop / Continue",
  "Ретроспективы, канбан, story map, mind map, SWOT, customer journey — и свои шаблоны команды.": "Retrospectives, kanban, story map, mind map, SWOT, customer journey — and your team’s own templates.",
  "Решено · {name}": "Resolved · {name}",
  "Решённые": "Resolved",
  "Родитель «{n}» не найден": "Parent «{n}» not found",
  "Родитель не найден": "Parent not found",
  "Розовый": "Pink",
  "Роли в воркспейсах и досках, ссылки с паролем и сроком, публичные доски по желанию.": "Roles in workspaces and boards, links with a password and expiry, public boards if you want them.",
  "Роль": "Role",
  "Роль владельца изменить нельзя": "The owner’s role can’t be changed",
  "Роль изменена": "Role changed",
  "Роль по ссылке": "Link role",
  "Роль участника": "Member role",
  "Ромб": "Diamond",
  "Сбросить": "Reset",
  "Сбросить доску": "Reset board",
  "Свернуть ветку": "Collapse branch",
  "Светлая": "Light",
  "Светлая тема": "Light theme",
  "Светлая, тёмная или как в системе": "Light, dark or as in the system",
  "Светло-серый": "Light gray",
  "Свободная регистрация": "Open sign-up",
  "Своих шаблонов пока нет": "No team templates yet",
  "Свой размер": "Custom size",
  "Свой сервер": "Self-hosting",
  "Свойства выделения": "Selection properties",
  "Своё время, минут": "Custom time, minutes",
  "Сделать администратором": "Make administrator",
  "Сделать прототип": "Build a prototype",
  "Сегодня": "Today",
  "Сегодня в 23:00 — обновление, до 10 минут без доступа": "Today at 11 pm — an update, up to 10 minutes of downtime",
  "Секрет": "Secret",
  "Секрет генерируется сервером и возвращается в ответе. Скоуп: `webhooks:manage`.": "The secret is generated by the server and returned in the response. Scope: `webhooks:manage`.",
  "Секрет для проверки подписи X-Lumo-Signature": "Secret for verifying the X-Lumo-Signature signature",
  "Секрет обновлён": "Secret updated",
  "Секрет подписи": "Signing secret",
  "Семь колонок по дням с задачами-стикерами.": "Seven columns, one per day, with sticky-note tasks.",
  "Сервисы": "Services",
  "Серый": "Gray",
  "Сессия входа устарела": "The sign-in session has expired",
  "Сессия входа устарела, попробуйте ещё раз": "The sign-in session has expired, please try again",
  "Сетка: линии": "Grid: lines",
  "Сетка: точки": "Grid: dots",
  "Сильные и слабые стороны, возможности и угрозы.": "Strengths, weaknesses, opportunities and threats.",
  "Синий": "Blue",
  "Сиреневый": "Lilac",
  "Скачать": "Download",
  "Скопировано": "Copied",
  "Скопировать": "Copy",
  "Скопировать ссылку на доску": "Copy board link",
  "Скоуп: `boards:read`.": "Scope: `boards:read`.",
  "Скоуп: `boards:write`, роль editor.": "Scope: `boards:write`, editor role.",
  "Скоуп: `boards:write`.": "Scope: `boards:write`.",
  "Скоуп: `comments:read`.": "Scope: `comments:read`.",
  "Скоуп: `comments:write`.": "Scope: `comments:write`.",
  "Скоуп: `workspace:read`.": "Scope: `workspace:read`.",
  "Скрыть": "Hide",
  "Скрыть объявление": "Hide announcement",
  "Скрыть/показать панели": "Hide/show panels",
  "Слайд 16:9": "Slide 16:9",
  "Слайд 4:3": "Slide 4:3",
  "Следовать": "Follow",
  "Следующая попытка": "Next attempt",
  "Следующее": "Next",
  "Следующий слайд": "Next slide",
  "Слишком большой запрос": "The request is too large",
  "Смотреть публичные доски": "Browse public boards",
  "Сначала": "Newest first",
  "Снять": "Remove",
  "Снять права администратора": "Remove administrator rights",
  "Снять с публикации": "Unpublish",
  "Соберите команду на одной доске": "Bring your team onto one board",
  "Собрать отзывы первых пользователей": "Collect feedback from first users",
  "Событие `ping` ставится в очередь и уходит в течение пары секунд.": "The `ping` event is queued and sent within a couple of seconds.",
  "Событие:": "Event:",
  "События": "Events",
  "События перестанут отправляться, журнал доставок будет удалён.": "Events will stop being sent and the delivery log will be deleted.",
  "Содержимое в формате экспорта": "Content in the export format",
  "Создайте доску за секунды и пригласите коллег ссылкой.": "Create a board in seconds and invite teammates with a link.",
  "Создайте доску и добавьте стикеры:": "Create a board and add sticky notes:",
  "Создайте токен в": "Create a token in",
  "Создайте токен, чтобы работать с досками из скриптов и интеграций.": "Create a token to work with boards from scripts and integrations.",
  "Создана доска": "Board created",
  "Создание досок и объектов, правки, импорт": "Creating boards and objects, editing, import",
  "Создание и изменение досок и объектов, импорт": "Creating and changing boards and objects, import",
  "Создание и настройка подписок": "Creating and configuring subscriptions",
  "Создать": "Create",
  "Создать аккаунт": "Create account",
  "Создать вебхук": "Create webhook",
  "Создать доску": "Create board",
  "Создать доску из шаблона": "Create a board from a template",
  "Создать объекты": "Create objects",
  "Создать токен": "Create token",
  "Создаёт и редактирует доски воркспейса": "Creates and edits workspace boards",
  "Сортировка": "Sort",
  "Соседний узел": "Sibling node",
  "Состояние": "Status",
  "Сохранено": "Saved",
  "Сохранить": "Save",
  "Сохранить версию": "Save version",
  "Сохранить доску как шаблон": "Save the board as a template",
  "Сохранить как шаблон": "Save as template",
  "Сохранить пароль": "Save password",
  "Сохранить текущую версию": "Save the current version",
  "Сохранить фрейм как шаблон": "Save the frame as a template",
  "Списки возвращают": "Lists return",
  "Списки досок, объекты, экспорт": "Board lists, objects, export",
  "Список": "List",
  "Список воркспейсов": "Workspace list",
  "Список воркспейсов и ролей": "Workspaces and roles",
  "Список досок": "List boards",
  "Срок действия": "Expiry",
  "Срок действия ссылки истёк": "The link has expired",
  "Ссылка": "Link",
  "Ссылка для сброса пароля": "Password reset link",
  "Ссылка для сброса устарела — запросите новую": "The reset link has expired — request a new one",
  "Ссылка скопирована": "Link copied",
  "Ссылка устарела": "The link has expired",
  "Ссылки": "Links",
  "Старая ссылка перестанет работать": "The old link will stop working",
  "Старт": "Start",
  "Старый секрет перестанет действовать сразу — обновите его на стороне получателя.": "The old secret stops working immediately — update it on the receiving side.",
  "Старый секрет перестаёт действовать сразу.": "The old secret stops working immediately.",
  "Статус": "Status",
  "Стикер": "Sticky note",
  "Стикеры, фигуры, коннекторы с обходом препятствий, перо, фреймы, mind map, таблицы и карточки.": "Sticky notes, shapes, connectors that route around obstacles, pen, frames, mind maps, tables and cards.",
  "Стрелка": "Arrow",
  "Строка заголовка": "Header row",
  "Схемы": "Diagrams",
  "Таймер": "Timer",
  "Таймер для всех": "A timer for everyone",
  "Так вас видят другие участники.": "This is how other participants see you.",
  "Теги": "Tags",
  "Теги сохранены": "Tags saved",
  "Текст": "Text",
  "Текст комментария": "Comment text",
  "Текст ячейки": "Cell text",
  "Текущее состояние сохранится в истории версий — его можно будет восстановить.": "The current state will be saved in the version history — you can restore it.",
  "Текущее состояние сохранится как отдельная версия — ничего не потеряется. Все участники сразу увидят восстановленную доску.": "The current state will be saved as a separate version — nothing is lost. Everyone will see the restored board right away.",
  "Текущий пароль": "Current password",
  "Текущий пароль неверен": "The current password is wrong",
  "Текущий пользователь и права токена": "Current user and token permissions",
  "Телефон": "Phone",
  "Тело запроса": "Request body",
  "Тело запроса (JSON)": "Request body (JSON)",
  "Тема": "Theme",
  "Тема как в системе": "System theme",
  "Тестовое событие": "Test event",
  "Тестовое событие отправлено": "Test event sent",
  "Тип линии: {type}": "Line type: {type}",
  "Тип события, например object.created": "Event type, for example object.created",
  "Токен «{name}» перестанет работать сразу. Интеграции, которые его используют, получат ошибку 401.": "The token «{name}» will stop working immediately. Integrations that use it will get a 401 error.",
  "Токен действует от вашего имени в пределах выбранных прав. Передавайте его в заголовке": "The token acts on your behalf within the selected permissions. Pass it in the header",
  "Токен не найден": "Token not found",
  "Токен отозван": "Token revoked",
  "Токен создан. Скопируйте его сейчас — больше он показан не будет.": "Token created. Copy it now — it won’t be shown again.",
  "Токенами можно управлять только из веб-интерфейса": "Tokens can only be managed from the web interface",
  "Токенов пока нет": "No tokens yet",
  "Только http(s)": "Only http(s)",
  "Только для внутренних вызовов": "Internal calls only",
  "Только доска «{name}»": "Only the board «{name}»",
  "Только доски этого воркспейса": "Only boards of this workspace",
  "Только комментарии": "Comments only",
  "Только приглашённые": "Invited people only",
  "Только просмотр": "View only",
  "Только свободные зависимости (MIT, Apache, BSD). Никакой телеметрии.": "Only free dependencies (MIT, Apache, BSD). No telemetry.",
  "Только события этой доски; null — весь воркспейс": "Only events of this board; null — the whole workspace",
  "Только содержимое фрейма (рекурсивно)": "Only the frame’s content (recursively)",
  "Тон": "Tone",
  "Требуется вход": "Sign-in required",
  "Тред решён": "Thread resolved",
  "Треды и ответы": "Threads and replies",
  "Треды комментариев доски": "Board comment threads",
  "Треды прямо на объектах, упоминания и уведомления — обсуждение не теряется.": "Threads right on objects, mentions and notifications — the discussion doesn’t get lost.",
  "Треугольник": "Triangle",
  "Тёмная": "Dark",
  "Тёмная тема": "Dark theme",
  "Тёмная тема ✓": "Dark theme ✓",
  "У аккаунта нет подтверждённого email": "The account has no verified email",
  "У меня есть аккаунт": "I have an account",
  "У токена нет скоупа {n}": "The token lacks the {n} scope",
  "Убрано из галереи": "Removed from the gallery",
  "Убрать аватар": "Remove avatar",
  "Убрать из галереи": "Remove from the gallery",
  "Убрать таймер": "Remove timer",
  "Уведомления": "Notifications",
  "Уведомления: {n} новых": "Notifications: {n} new",
  "Удаление": "Deletion",
  "Удалено": "Deleted",
  "Удалены объекты": "Objects deleted",
  "Удалить": "Delete",
  "Удалить {name}": "Remove {name}",
  "Удалить вебхук": "Delete webhook",
  "Удалить вебхук?": "Delete the webhook?",
  "Удалить воркспейс": "Delete workspace",
  "Удалить воркспейс?": "Delete the workspace?",
  "Удалить доску может владелец": "Only the owner can delete the board",
  "Удалить из воркспейса": "Remove from workspace",
  "Удалить может автор или владелец доски": "Only the author or the board owner can delete it",
  "Удалить навсегда": "Delete forever",
  "Удалить несколько объектов": "Delete several objects",
  "Удалить обсуждение": "Delete discussion",
  "Удалить обсуждение может автор или владелец доски": "Only the author or the board owner can delete the discussion",
  "Удалить объект": "Delete object",
  "Удалить последний столбец": "Delete last column",
  "Удалить последнюю строку": "Delete last row",
  "Удалить пункт": "Delete item",
  "Удалять администраторов может только владелец": "Only the owner can remove administrators",
  "Удалён участник": "Member removed",
  "Удалённый пользователь": "Deleted user",
  "Укажите имя": "Enter a name",
  "Укажите название": "Enter a name",
  "Упоминания, ответы и приглашения появятся здесь.": "Mentions, replies and invitations will show up here.",
  "Упомянуть": "Mention",
  "Управление вебхуками (нужна роль администратора воркспейса)": "Managing webhooks (requires the workspace administrator role)",
  "Управляет участниками и всеми досками": "Manages members and all boards",
  "Участник": "Member",
  "Участник не найден": "Member not found",
  "Участник удалён": "Member removed",
  "Участники · {n}": "Members · {n}",
  "Участники кликают по объектам, чтобы отдать голоса.": "Participants click objects to cast their votes.",
  "Участники перемещены к вам": "Participants moved to you",
  "Участники потеряют доступ. Доску можно восстановить здесь же в течение 30 дней, потом она удалится навсегда.": "Participants will lose access. The board can be restored here within 30 days, after that it’s deleted forever.",
  "Учётные данные в адресе запрещены": "Credentials in the address are not allowed",
  "Файл больше 20 МБ": "The file is larger than 20 MB",
  "Файл больше {n} МБ": "The file is larger than {n} MB",
  "Файл не найден": "File not found",
  "Файл не передан": "No file was sent",
  "Файл экспорта Lumo (.lumo.json).": "Lumo export file (.lumo.json).",
  "Фигура": "Shape",
  "Фигура с текстом": "Shape with text",
  "Фильтр": "Filter",
  "Фильтр по типам через запятую: `sticky,shape`": "Filter by types, comma-separated: `sticky,shape`",
  "Фиолетовый": "Violet",
  "Фон холста": "Canvas background",
  "Формат": "Format",
  "Формат `lumo.board` v1 — его же принимает импорт. Скоуп: `boards:read`.": "The `lumo.board` v1 format — the same one import accepts. Scope: `boards:read`.",
  "Форматирование": "Formatting",
  "Форматирование текста": "Text formatting",
  "Фрейм": "Frame",
  "Фрейм не найден": "Frame not found",
  "Фрейм-родитель": "Parent frame",
  "Фреймы": "Frames",
  "Фреймы по страницам": "Frames as pages",
  "Фреймы по страницам ({n})": "Frames as pages ({n})",
  "Холст доски": "Board canvas",
  "Цвет ветки": "Branch color",
  "Цвет курсора": "Cursor color",
  "Центральная идея": "Central idea",
  "Центральная идея и ветки. Tab — новая ветка, Enter — соседняя.": "A central idea and branches. Tab adds a branch, Enter a sibling.",
  "Частичное обновление: геометрия, `props` (сливаются с текущими), `text`. Скоуп: `boards:write`, роль editor.": "Partial update: geometry, `props` (merged with the current ones), `text`. Scope: `boards:write`, editor role.",
  "Чек-лист": "Checklist",
  "Черта": "Bar",
  "Чистый лист с линейной сеткой и привязкой.": "A blank page with a line grid and snapping.",
  "Чтение досок": "Reading boards",
  "Чтение комментариев": "Reading comments",
  "Что начать делать, что прекратить и что продолжить.": "What to start doing, what to stop and what to continue.",
  "Что сделать": "What to do",
  "Что экспортировать": "What to export",
  "Что-то пошло не так": "Something went wrong",
  "Чужие голоса скрыты до итогов": "Others’ votes are hidden until the results",
  "Шаблон не найден": "Template not found",
  "Шаблон появится в разделе «Шаблоны» вашего воркспейса.": "The template will appear in your workspace’s «Templates» section.",
  "Шаблон сохранён": "Template saved",
  "Шаблон, например `builtin:kanban`": "Template, for example `builtin:kanban`",
  "Шаблоны": "Templates",
  "Шаблоны воркспейса": "Workspace templates",
  "Шаблоны для команд": "Templates for teams",
  "Штамп": "Stamp",
  "Экспорт доски": "Export board",
  "Экспорт доски в JSON": "Export board to JSON",
  "Экспорт…": "Export…",
  "Эмоции команды: что злило, что расстроило, что порадовало.": "The team’s emotions: what made us mad, sad and glad.",
  "Этапы пути пользователя: действия, мысли, эмоции, возможности.": "Stages of the user journey: actions, thoughts, emotions, opportunities.",
  "Это владелец доски": "This is the board owner",
  "Это не JSON-файл": "This is not a JSON file",
  "Это последний администратор": "This is the last administrator",
  "Этот email уже занят": "This email is already taken",
  "Этот адрес уже занят": "This address is already taken",
  "Этот человек уже в воркспейсе": "This person is already in the workspace",
  "Язык": "Language",
  "Язык интерфейса": "Interface language",
  "Янтарный": "Amber",
  "администратором": "an administrator",
  "админка admin блокировка": "admin administration block",
  "админка admin инстанс": "admin administration instance",
  "админка admin модерация": "admin administration moderation",
  "админка admin регистрация объявление": "admin administration sign-up announcement",
  "бесконечной": "infinite",
  "бессрочный": "no expiry",
  "в пути": "on the way",
  "ведёт презентацию": "is presenting",
  "воркспейс": "workspace",
  "вручную": "manual",
  "все доски": "all boards",
  "выбрать": "select",
  "выполнить": "run",
  "голосуют редакторы доски": "board editors vote",
  "гостем": "a guest",
  "дашборд главная": "dashboard home",
  "действует до {date}": "valid until {date}",
  "дизайн, бэкенд": "design, backend",
  "дн": "d",
  "до 200). Лимит запросов считается на токен; текущие значения — в заголовках": "up to 200). The rate limit is per token; current values are in the headers",
  "до {n}": "up to {n}",
  "доска «{name}»": "board «{name}»",
  "доске": "board",
  "досок открыто ·": "boards open ·",
  "ещё": "more",
  "за 14 дней": "in 14 days",
  "из": "of",
  "истёк {date}": "expired {date}",
  "клик": "click",
  "колесо": "wheel",
  "мин": "min",
  "мс": "ms",
  "настроена": "configured",
  "настройки api token": "settings api token",
  "настройки settings": "settings",
  "настройки webhook": "settings webhook",
  "не заходил": "never signed in",
  "не настроена — письма в логе": "not configured — emails go to the log",
  "не отвечает": "not responding",
  "неделя": "week",
  "об.": "obj.",
  "ок": "ok",
  "осталось": "left",
  "ответ(ов)": "replies",
  "открыть / закрыть": "open / close",
  "по умолчанию:": "default:",
  "подключений": "connections",
  "приглашает в «": "invites you to «",
  "пункт": "item",
  "работает {time}": "running {time}",
  "разработчикам openapi": "developers openapi",
  "решено": "resolved",
  "с {time}": "since {time}",
  "с правами": "with role",
  "событий": "events",
  "тянуть": "drag",
  "удалена {time}": "deleted {time}",
  "участником": "a member",
  "файлы {files} · доски {boards}": "files {files} · boards {boards}",
  "ч": "h",
  "— перетаскивайте, рисуйте, двойной клик для текста": "— drag, draw, double-click for text"
}
